<template>
  <b-card>
    <b-card-title class="mb-1">
      <feather-icon
        icon="UserIcon"
        size="24"
        class="mr-1"
      />
      Persönliche Informationen
    </b-card-title>

    <b-card-body>
      <!-- User Avatar & Basic Info -->
      <div class="d-flex align-items-start mb-3">
        <b-avatar
          :text="avatarText"
          :variant="avatarVariant"
          size="104px"
          rounded
          class="mr-2"
        />
        <div class="ml-1">
          <h4 class="mb-1">
            {{ fullName }}
          </h4>
          <p class="card-text mb-0">
            @{{ user.username }}
          </p>
          <div class="mt-1">
            <b-badge
              :variant="statusVariant"
              class="mr-1"
            >
              <feather-icon
                :icon="statusIcon"
                size="12"
                class="mr-25"
              />
              {{ statusLabel }}
            </b-badge>
            <b-badge
              v-if="user.blocked"
              variant="danger"
            >
              <feather-icon
                icon="LockIcon"
                size="12"
                class="mr-25"
              />
              Blockiert
            </b-badge>
          </div>
        </div>
      </div>

      <!-- Detailed Information Table -->
      <table class="w-100 mt-2">
        <tbody>
          <tr>
            <td
              class="pb-1"
              width="40%"
            >
              <feather-icon
                icon="HashIcon"
                size="14"
                class="mr-1"
              />
              <span class="font-weight-bold">Benutzer-ID</span>
            </td>
            <td class="pb-1">
              {{ user.id }}
            </td>
          </tr>
          <tr>
            <td class="pb-1">
              <feather-icon
                icon="MailIcon"
                size="14"
                class="mr-1"
              />
              <span class="font-weight-bold">E-Mail</span>
            </td>
            <td class="pb-1">
              <a :href="`mailto:${user.email}`">{{ user.email }}</a>
            </td>
          </tr>
          <tr>
            <td class="pb-1">
              <feather-icon
                icon="BriefcaseIcon"
                size="14"
                class="mr-1"
              />
              <span class="font-weight-bold">Rolle</span>
            </td>
            <td class="pb-1">
              <b-badge variant="light-primary">
                {{ user.role ? user.role.name : 'N/A' }}
              </b-badge>
            </td>
          </tr>
          <tr>
            <td class="pb-1">
              <feather-icon
                icon="CalendarIcon"
                size="14"
                class="mr-1"
              />
              <span class="font-weight-bold">Mitglied seit</span>
            </td>
            <td class="pb-1">
              {{ getFormattedDate(user.created_at) }}
            </td>
          </tr>
          <tr>
            <td class="pb-1">
              <feather-icon
                icon="ClockIcon"
                size="14"
                class="mr-1"
              />
              <span class="font-weight-bold">Zuletzt aktualisiert</span>
            </td>
            <td class="pb-1">
              {{ getFormattedDate(user.updated_at) }}
            </td>
          </tr>
          <tr v-if="user.provider">
            <td class="pb-1">
              <feather-icon
                icon="ShieldIcon"
                size="14"
                class="mr-1"
              />
              <span class="font-weight-bold">Auth Provider</span>
            </td>
            <td class="pb-1">
              {{ user.provider }}
            </td>
          </tr>
        </tbody>
      </table>

    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardBody,
  BAvatar,
  BBadge,
} from 'bootstrap-vue'
import helper from '@/helper/helper'

export default {
  components: {
    BCard,
    BCardTitle,
    BCardBody,
    BAvatar,
    BBadge,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { getFormattedDate } = helper()
    return { getFormattedDate }
  },
  computed: {
    fullName() {
      if (this.user.firstName && this.user.lastName) {
        return `${this.user.firstName} ${this.user.lastName}`
      }
      return this.user.username || 'N/A'
    },
    avatarText() {
      if (this.user.firstName && this.user.lastName) {
        return `${this.user.firstName[0]}${this.user.lastName[0]}`
      }
      return this.user.username ? this.user.username.substring(0, 2).toUpperCase() : '?'
    },
    avatarVariant() {
      if (this.user.blocked) return 'danger'
      if (this.user.confirmed) return 'success'
      return 'warning'
    },
    statusLabel() {
      if (this.user.blocked) return 'Blockiert'
      if (this.user.confirmed) return 'Aktiv'
      return 'Inaktiv'
    },
    statusVariant() {
      if (this.user.blocked) return 'danger'
      if (this.user.confirmed) return 'success'
      return 'warning'
    },
    statusIcon() {
      if (this.user.blocked) return 'XCircleIcon'
      if (this.user.confirmed) return 'CheckCircleIcon'
      return 'AlertCircleIcon'
    },
  },
}
</script>

<style lang="scss" scoped>
.card-text {
  color: #6e6b7b;
}

table td {
  vertical-align: middle;
}

.font-weight-bold {
  font-weight: 600;
}

</style>
